import React, { useContext } from "react";
import ReactDOM from "react-dom";
import SnackbarContext from "../../context/snackbar.context";
import "./snackbar.scss";

const Snackbar = () => {
  const snackbarCtx = useContext(SnackbarContext);

  return ReactDOM.createPortal(
    <div>
      <div
        className={`snackbar__container ${
          snackbarCtx.data.type === "SUCCESS" ? "snackbar__container__success" : "snackbar__container__error"
        }`}
      >
        <div className="snackbar__label">{snackbarCtx.data.message}</div>
        <div className="snackbar__dismiss" onClick={snackbarCtx.onClose}>
          &times;
        </div>
      </div>
    </div>,
    // @ts-ignore
    document.getElementById("snackbar__root")
  );
};

export default Snackbar;
